var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "432px",
    height: "26.5px",
    viewBox: "0 0 432 26.5",
    enableBackground: "new 0 0 432 26.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.592,21.236H3.053l10.718-19.63h7.646l10.521,19.63H25.36l-1.898-3.27H11.504L9.592,21.236z  M13.771,13.248h7.541L17.502,6.3L13.771,13.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.821,16.49h13.065v4.746H35.823V1.606h5.999V16.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M68.092,21.236h-5.985V6.418h-8.213V1.606h22.412v4.812h-8.213V21.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M101.863,6.392H86.399v2.966h14.567v4.126H86.399v3.005h15.702v4.746H80.414V1.606h21.45V6.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.913,1.606c3.111,0,5.229,0.461,6.354,1.384s1.688,2.606,1.688,5.049c0,1.696-0.25,2.958-0.751,3.784 s-1.34,1.38-2.518,1.661c1.037,0.246,1.815,0.681,2.333,1.305s0.778,1.433,0.778,2.426v4.021h-5.999v-2.992 c0-0.773-0.183-1.306-0.547-1.596c-0.365-0.29-1.083-0.435-2.156-0.435h-8.938v5.022h-6.012V1.606H122.913z M122.688,6.498 h-9.532v4.799h9.532c0.8,0,1.36-0.187,1.681-0.561c0.321-0.373,0.481-1.048,0.481-2.023c0-0.773-0.171-1.336-0.514-1.688 S123.444,6.498,122.688,6.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M162.814,21.236h-8.78L142.261,6.959v14.277h-5.985V1.606h8.873l11.694,14.396V1.606h5.972V21.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M172.777,21.236h-6.539l10.718-19.63h7.646l10.521,19.63h-6.579l-1.898-3.27h-11.958L172.777,21.236z  M176.956,13.248h7.541l-3.81-6.948L176.956,13.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M208.486,21.236h-5.985V6.418h-8.213V1.606h22.412v4.812h-8.213V21.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M227.07,21.236h-5.998V1.606h5.998V21.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M244.969,15.699l7.832-14.093h6.367L248.7,21.236h-7.265l-10.375-19.63h6.539L244.969,15.699z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M283.974,6.392H268.51v2.966h14.566v4.126H268.51v3.005h15.701v4.746h-21.687V1.606h21.449V6.392z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M340.779,1.606c1.336,0,2.4,0.064,3.196,0.191s1.47,0.336,2.024,0.626c0.992,0.519,1.713,1.29,2.162,2.313 c0.447,1.024,0.672,2.437,0.672,4.239c0,2.689-0.448,4.59-1.345,5.702c-0.896,1.112-2.413,1.668-4.548,1.668h-11.207v4.891h-6.012 V1.606H340.779z M340.568,6.498h-8.834v4.97h8.834c0.799,0,1.359-0.195,1.681-0.587c0.32-0.391,0.481-1.087,0.481-2.089 c0-0.8-0.172-1.382-0.515-1.747S341.324,6.498,340.568,6.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M356.594,21.236h-6.539l10.719-19.63h7.646l10.521,19.63h-6.579l-1.898-3.27h-11.957L356.594,21.236z  M360.773,13.248h7.541L364.504,6.3L360.773,13.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M392.305,21.236h-5.986V6.418h-8.213V1.606h22.412v4.812h-8.213V21.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M410.664,21.236h-5.985V1.606h5.985v7.211h12.287V1.606h6.025v19.63h-6.025v-7.672h-12.287V21.236z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#CB6828",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 307.5,
    y1: 2,
    x2: 298,
    y2: 24.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7df9c6ae2fafb1c9a993dd0bd213ccc0.svg";
export { ForwardRef as ReactComponent };